
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import { Tabla } from "../../../components/Table/Table";
import { actuacionesService } from "../../../_services/actuaciones.service";
import LoadingModal from "../../../components/LoadingModal/LoadingModal";
import DetallesModal from "../MesaEntradasJudicial/Components/DetallesModal";
import DeudasModal from "../MesaEntradasJudicial/Components/DeudasModal";
import { DollarSign, Eye } from "react-feather";
import { diffDays } from "../../../utils/utils";
import moment from "moment";
import { Filter } from "../MesaEntradasJudicial/Components/Filter";
import { configuracionService } from "../../../_services/configuracion.service";
import { RecursosComercios } from "../../../constants";
import { useUser } from "../../../hooks/useUser";
import { useHistory } from "react-router-dom";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";
import { useDispatch, useSelector } from "react-redux";
import { mesasEntradaActions } from "../../../redux/MesasEntrada/actions";
import { getUltimaActuacion } from "../../../utils/actuaciones";

const Juicios = ({ abogado, dataList, setDataList, tab, setTab }) => {
  const { mesaExtrajudicial, fechaInicial } = useSelector((e) => e.mesasEntrada);
  const dispatch = useDispatch();

  const [showFilter, setShowFilter] = useState(false);
  const [showTable, setShowTable] = useState(true);
  // const [type, setType] = useState("extrajudicial");
  const [filters, setFilters] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [deudasShow, setDeudasShow] = useState(false);

  const [fechaInicialConfig, setFechaInicialConfig] = useState("");

  const [totalData, setTotalData] = useState(mesaExtrajudicial || []);

  const user = useUser();
  const history = useHistory();

  // const [page, setPage] = useState(1);
  // const [limit, setLimit] = useState(10);

  useEffect(() => {
    dispatch(mesasEntradaActions.saveMesaExtrajudicial(totalData));
  }, [totalData]);

  useEffect(() => {
    if (fechaInicial) {
      setFechaInicialConfig(fechaInicial);
    }
  }, [fechaInicial]);

  useEffect(() => {
    if (tab === "ACTIVOS") {
      if (mesaExtrajudicial?.length) {
        getActivosData(mesaExtrajudicial);
      }
      else if (!dataList?.length) {
        getData(filters);
      }
      else if (!totalData?.length) {
        getData(filters);
      } else {
        getActivosData(totalData);
      }
    }
    else if (tab === "PLAN_PAGOS") {
      getDataPlanPago(totalData);
    }
    else if (tab === "TODOS") {
      getTodosExtrajudicial(totalData);
    } else {
      getDataSinValorar(totalData);
    }

  }, [tab]);

  const getData = async (data) => {
    setShowLoading(true);

    const res = await actuacionesService.actuacionesSearch({
      data: {
        ...data,
        abogado,
      },
      abogado,
      grupo: 2,
      desde: moment().subtract(120, "day").format("YYYY-MM-DD")
    }, "extrajudicial");


    setTotalData(res);

    if (tab === "ACTIVOS") {
      getActivosData(res);
    } else if (tab === "SIN_EVALUAR") {
      getDataSinValorar(res);
    }
    else if (tab === "TODOS") {
      getTodosExtrajudicial(res);
    } else {
      getDataPlanPago(res);
    }

    setShowLoading(false);
  };

  const actuacionesFilter = async (data) => {
    if(!data.recurso && !data.nro_imponible && !data.imponible){
      await getData(data);
    }
    else if (data?.recurso) {
      await getData(data);
    }
    else {
      setShowLoading(true);

      const recursos = await actuacionesService.recursosxImp({ tipo: "I", imponible: data?.nro_imponible });

      let result = [];

      for (const prop of recursos) {
        const res = await actuacionesService.actuacionesSearch({
          data: {
            ...data,
            recurso: prop.RECURSO,
            abogado,
          },
          abogado,
          grupo: 2,
          desde: moment().subtract(120, "day").format("YYYY-MM-DD")
        }, "extrajudicial");

        if (res?.length) {
          result = result.concat(res);
        }
      }

      setTotalData(result);

      if (tab === "ACTIVOS") {
        getActivosData(result);
      } else if (tab === "SIN_EVALUAR") {
        getDataSinValorar(result);
      }
      else if (tab === "TODOS") {
        getTodosExtrajudicial(result);
      } else {
        getDataPlanPago(result);
      }

      setShowLoading(false);
    }
  };

  const getActivosData = async (data) => {
    setShowLoading(true);
    if (data?.length && Array.isArray(data)) {
      let fecha_inicial = fechaInicial;
      if (!fechaInicial) {
        const configuracion = await configuracionService.getConfiguracion({ key: "FECHA_INICIAL" });
        fecha_inicial = configuracion?.value;

        setFechaInicialConfig(fecha_inicial);
        dispatch(mesasEntradaActions.fechaInicial(fecha_inicial));
      }

      const filtered = data.filter((e) => {
        let gestionLegal = false;

        let historicos = e?.imponibles?.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(moment(a.fecha).format("YYYY-MM-DD")) - new Date(moment(b.fecha).format("YYYY-MM-DD")));

        if (historicos?.length) {
          const historico = historicos[historicos.length - 1];

          if (historico?.SITUACION === "Gestión Legal") {
            gestionLegal = new Date(historico.fecha) >= new Date(fecha_inicial);
          }
        }

        const actuaciones = e?.imponibles?.map((imp) => imp?.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

        let extrajudicial = false;
        if (actuaciones?.length) {
          let last = actuaciones[actuaciones.length - 1];

          extrajudicial = last.tipo_etapa?.grupo === 2 && new Date(last.fecha).getTime() >= new Date(fecha_inicial).getTime();
        }

        return gestionLegal || extrajudicial;
      });

      setDataList(filtered);
      setShowLoading(false);
    } else {
      setDataList([]);
      setShowLoading(false);
    }
  };

  const getDataSinValorar = async (data) => {
    setShowLoading(true);

    if (data?.length && Array.isArray(data)) {
      const configuracion = await configuracionService.getConfiguracion({ key: "SIN_EVALUAR" });
      const fechaSinEnvaluar = configuracion?.value;

      const filtered = data.filter((e) => {
        let historicos = e?.imponibles?.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

        const actuaciones = e?.imponibles?.map((imp) => imp?.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

        if (!historicos?.length && !actuaciones?.length) {
          return false;
        }

        let gestionLegal = true;
        let extrajudicial = true;

        if (historicos?.length) {
          const historico = historicos[historicos.length - 1];

          if (historico?.SITUACION === "Gestión Legal") {
            gestionLegal = new Date(historico.fecha) < new Date(fechaInicialConfig) && new Date(historico.fecha) >= new Date(fechaSinEnvaluar) && !historico.titulo;
          } else {
            gestionLegal = false;
          }

          if (actuaciones?.length) {
            let last = actuaciones[actuaciones.length - 1];

            if (new Date(last.fecha) > new Date(historico.fecha)) {
              extrajudicial = last.tipo_etapa?.grupo === 2;
            } else {
              extrajudicial = false;
            }
          }
          else {
            extrajudicial = false;
          }
        }
        else if (actuaciones?.length) {
          let last = actuaciones[actuaciones.length - 1];

          if (new Date(last.fecha) < new Date(fechaInicialConfig)) {
            extrajudicial = last.tipo_etapa?.grupo === 2 && last.tipo_etapa?.grupo === 2 && new Date(last.fecha) >= new Date(fechaSinEnvaluar);
          }
        } else {
          extrajudicial = false;
        }

        return gestionLegal || extrajudicial;
      });

      setDataList(filtered);
      setShowLoading(false);
    } else {
      setDataList([]);
      setShowLoading(false);
    }
  };

  const getDataPlanPago = async (data) => {
    setShowLoading(true);

    if (data?.length && Array.isArray(data)) {
      const filtered = data.filter((e) => {
        let plandepago = "";

        let historicos = e?.imponibles?.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

        if (historicos?.length) {
          const historico = historicos[historicos.length - 1];

          if (historico?.SITUACION === "Plan de Pagos") {
            //   plandepago = new Date(historico.fecha) >= new Date(fechaInicialConfig);
            plandepago = historico?.SITUACION === "Plan de Pagos";

            const actuaciones = e?.imponibles?.map((imp) => imp?.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

            if (actuaciones?.length) {
              let last = actuaciones[actuaciones.length - 1];

              plandepago = new Date(last.fecha).getTime() < new Date(historico.fecha).getTime();
            }
          }
        }

        return plandepago;
      });

      setDataList(filtered);
      setShowLoading(false);
    } else {
      setDataList([]);
      setShowLoading(false);
    }
  };

  const getTodosExtrajudicial = async (data) => {
    setShowLoading(true);

    if (data?.length && Array.isArray(data)) {
      const filtered = data.filter((e) => {
        let historicos = e?.imponibles?.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

        const actuaciones = e?.imponibles?.map((imp) => imp?.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

        if (!historicos?.length && !actuaciones?.length) {
          return false;
        }

        let gestionLegal = true;
        let extrajudicial = true;

        if (historicos?.length) {
          const historico = historicos[historicos.length - 1];

          if (historico?.SITUACION === "Gestión Legal" || historico?.SITUACION === "Plan de Pagos") {
            gestionLegal = !historico.titulo;
          } else {
            gestionLegal = false;
          }

          if (actuaciones?.length) {
            let last = actuaciones[actuaciones.length - 1];

            if (new Date(last.fecha) > new Date(historico.fecha)) {
              extrajudicial = last.tipo_etapa?.grupo === 2;
            } else {
              extrajudicial = false;
            }
          }
          else {
            extrajudicial = false;
          }
        }
        else if (actuaciones?.length) {
          let last = actuaciones[actuaciones.length - 1];

          extrajudicial = last.tipo_etapa?.grupo === 2;
        } else {
          extrajudicial = false;
        }

        return gestionLegal || extrajudicial;
      });

      setDataList(filtered);
      setShowLoading(false);
    } else {
      setDataList([]);
      setShowLoading(false);
    }
  };

  const handleShow = (e) => {
    setData(e);
    setShow(true);
  };

  const handleClose = () => {
    setData([]);
    setShow(false);
  };

  const handleOpenDeudas = (e) => {
    setData(e?.imponibles);
    setDeudasShow(true);
  };

  const handleCloseDeudas = () => {
    setData([]);
    setDeudasShow(false);
  };

  const columns = [
    {
      title: "ABOGADO",
      dataIndex: "abogado",
      hidden: user.abogado !== "A00"
    },
    {
      title: "CONTRIBUYENTE",
      dataIndex: "apellnom",
    },
    {
      title: "IMPONIBLE",
      render: (a, row) => {
        return (
          <div className="d-flex">
            <Eye
              className="mx-2 action-table"
              onClick={() => handleShow(row)}
            />
          </div>
        );
      },
    },
    {
      title: "CATEGORIA",
      dataIndex: "categoria",
    },
    {
      title: "RECURSOS",
      dataIndex: "recursos",
      render: (a, row) => {
        return (
          <div>
            {row.recursos?.length && row.recursos.map((e, i) => {
              return (
                <div key={`rec_${i}`}>{e}</div>
              );
            })}
          </div>
        );
      },
    },
    {
      title: "MONTO",
      dataIndex: "monto",
      render: (a, row) => {
        return (
          <div className="d-flex">
            <DollarSign
              className="mx-2 action-table"
              onClick={() => handleOpenDeudas(row)}
            />
          </div>
        );
      },
    },
    {
      title: "SITUACIÓN",
      dataIndex: "situacion",
    },
    {
      title: "FECHA INICIAL",
      dataIndex: "fecha_inicial",
    },
    {
      title: "FECHA LIMITE",
      dataIndex: "fecha_limite",
      render: (a, row) => {
        return (
          <div className="d-flex">
            <div className={!row.sin_color ? row.color_dias : ""}>
              {row.fecha_limite}
            </div>
          </div>
        );
      },
    },
    {
      title: "ACTUACIONES",
      dataIndex: "actuaciones",
      render: (a, row) => {
        let tipo = "";
        let recurso = "";
        if (row.recursos?.length) {
          recurso = row.recursos?.length ? row.recursos[row.recursos.length - 1] : "";
        }
        if (recurso) {
          tipo = RecursosComercios.includes(recurso) ? "comercios" : "inmuebles";
        }

        const actuacion = getUltimaActuacion(row);

        return (
          <div className="d-flex">
            <div>
              <Link className="nav-link" to={`/gestion?grupo=${2}&tipo=${tipo}&nombre=${row.apellnom || row.APYNOM}&imponible=${actuacion.NRO_IMPONIBLE || actuacion.imponible}&recurso=${actuacion.RECURSO || actuacion.recurso}&abogado=${row.abogado}`}>Ir a gestión</Link>
            </div>
          </div>
        );
      },
      hidden: user.rol === "guest"
    },
  ];

  const formatData = (arrayData) => {
    try {
      if (!arrayData?.length || !Array.isArray(arrayData)) {
        return [];
      }

      let res = arrayData.map((item) => {
        let fecha_inicial = null;
        let situacion = null;

        if (item?.imponibles?.length) {
          const imponibles = item.imponibles.filter(e => e?.actuaciones?.length);
          const imponible = imponibles[imponibles.length - 1];

          if (imponible?.actuaciones?.length) {
            const actuaciones = imponible.actuaciones.sort((a, b) => new Date(a?.fecha).getTime() - new Date(b?.fecha).getTime());
            const actuacion = actuaciones[actuaciones.length - 1];

            fecha_inicial = actuacion.fecha;
            situacion = actuacion?.tipo_etapa?.grupo === 2 ? "Gestión Legal" : "Título Ejecutivo";
          }

          let historicos = item?.imponibles.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(a?.fecha).getTime() - new Date(b?.fecha).getTime());

          if (historicos?.length) {
            const historico = historicos[historicos.length - 1];

            if (!fecha_inicial || (new Date(historico.fecha) > new Date(fecha_inicial))) {
              fecha_inicial = historico.fecha;
              situacion = historico.SITUACION;
            }
          }
        }

        let diferenciaDias = diffDays(fecha_inicial);
        const fecha_limite = moment(fecha_inicial).add(90, "days").format("DD/MM/YYYY");

        const recursos = item.imponibles?.reduce((prev, current) => {
          const repeat = prev.some((e) => e === current.RECURSO);

          return repeat ? prev : [...prev, current.RECURSO];
        }, []);

        return {
          ...item,
          fecha_inicial: moment(fecha_inicial).format("DD/MM/YYYY"),
          fecha_limite,
          color_dias: diferenciaDias >= 0 ? diferenciaDias < 10 ? "tiempo-cerca" : "a-tiempo" : "vencido",
          categoria: "1 con cap contr",
          recursos,
          sin_color: new Date(fecha_inicial) < new Date(fechaInicialConfig) || tab === "SIN_EVALUAR",
          situacion,
          tab
        };
      });

      return res;
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  function exportData(list) {
    let filename = `mesaextrajudicial_${new Date().getTime()}.xlsx`;

    const dataList = list.reduce((prev, current) => {
      let arr = [];

      if (current.imponibles?.length) {
        arr = current.imponibles.reduce((prevImps, e) => {
          if (!prevImps.some(p => (p["IMPONIBLE"] === e.IMPONIBLE || p["IMPONIBLE"] === e.NRO_IMPONIBLE) && p["RECURSO"] === e.RECURSO)) {
            let fecha = e.historico?.fecha || "";

            if (e.actuaciones?.length && !fecha) {
              const date = e.actuaciones[e.actuaciones.length - 1].fecha;

              fecha = moment(date).format("DD-MM-YYYY");
            }

            return [
              ...prevImps,
              {
                "FECHA": fecha,
                "IMPONIBLE": e.IMPONIBLE || e.NRO_IMPONIBLE,
                "RECURSO": e.RECURSO,
                "ABOGADO": current.abogado,
                "CONTRIBUYENTE": current.apellnom,
              }
            ];
          } else {
            return prevImps;
          }
        }, []);

        return [...prev, ...arr];
      } else {
        return prev;
      }
    }, []);

    let name = "Abogados";

    return {
      dataList,
      filename,
      name
    };
  }

  return (
    <div className="">
      <div className="buttons-filter">
        <h3 className="mr-3">Filtros:</h3>
        <div className="button-filter">
          {showFilter ? (
            <Button
              variant="danger"
              onClick={() => setShowFilter(false)}
              className="danger-button d-flex align-items-center"
              style={{ maxWidth: 105 }}
            >
              <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
            </Button>
          )
            : (
              <Button
                onClick={() => setShowFilter(true)}
                className="custom-button d-flex align-items-center"
                style={{ maxWidth: 105 }}
              ><FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
              </Button>
            )}
        </div>
      </div>
      <div className="section-filter">
        <Filter
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          style={{ marginBottom: "30px" }}
          action={actuacionesFilter}
          setShowTable={setShowTable}
          setData={setDataList}
          setFilters={setFilters}
        />
      </div>

      {showTable ? (
        <>
          <div className="d-flex align-items-center justify-content-between">
            <div className="mb-3 fw-600" style={{ textAlign: "start" }}>
              CONTRIBUYENTES ASIGNADOS
            </div>
            { user.rol !== "guest" ?
              <div className="mb-2" style={{ maxWidth: 170 }}>
                <DescargarExcel data={exportData(dataList)} />
              </div> :
              null
            }
          </div>
          <div className="data-content">
            <div className="d-flex flex-row align-items-start section-table">
              <div className="table-tabs">
                <div className={tab === "ACTIVOS" ? "selected-table-tab" : "table-tab"} onClick={() => setTab("ACTIVOS")}>ACTIVOS</div>
                <div className={tab === "SIN_EVALUAR" ? "selected-table-tab" : "table-tab"} onClick={() => setTab("SIN_EVALUAR")}>SIN EVALUAR</div>
                <div className={tab === "PLAN_PAGOS" ? "selected-table-tab" : "table-tab"} onClick={() => setTab("PLAN_PAGOS")}>PLAN DE PAGOS</div>
                <div className={tab === "TODOS" ? "selected-table-tab" : "table-tab"} onClick={() => setTab("TODOS")}>TODOS</div>
                {
                  user.rol !== "guest"
                    ? <div className={"table-tab"} onClick={() => history.push(`/gestion?grupo=${2}&tipo=inmuebles&historico=true&extrajudicial=true&abogado=${abogado}`)}>BUSCAR HISTORICO</div>
                    : null
                }
              </div>
              <div className="data-table">
                <Tabla
                  dataList={formatData(dataList)}
                  columns={columns}
                // setPage={setPage}
                // setLimit={setLimit}
                />
              </div>
            </div>
          </div>
        </>
      ) : null}

      {show && <DetallesModal show={show} handleClose={handleClose} data={data} />}
      {deudasShow && <DeudasModal show={deudasShow} handleClose={handleCloseDeudas} imponibles={data} />}
      {showLoading && <LoadingModal show={showLoading} loading={true} grupo={2} mesas />}
    </div>
  );
};


export default Juicios;